// extracted by mini-css-extract-plugin
export default {"userCard":"UserCard_userCard__tT-6-","avatar":"UserCard_avatar__1Ax7k","bio":"UserCard_bio__Iaj-v","empty":"UserCard_empty__G0flS"};